import { Directive, HostListener, Self } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';

@Directive({
  selector: '[fcFormUnloadWarning]',
  standalone: false
})
export class FormUnloadWarningDirective {
  constructor(@Self() readonly formGroup: FormGroupDirective) {}

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload() {
    return !this.formGroup.dirty;
  }
}
